/*
React-Quill v1.0.0
https://github.com/zenoamaro/react-quill
*/
var Quill = require('quill');
var Component = require('./component');

module.exports = Component;
module.exports.default = Component;
module.exports.Quill = Quill;
module.exports.Mixin = require('./mixin');
module.exports.Toolbar = require('./toolbar');



//////////////////
// WEBPACK FOOTER
// ./~/react-quill/lib/index.js
// module id = 575
// module chunks = 0